
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import ToolSelector from "@/components/Apologetics/ToolSelector";
import HeroSection from "@/components/Apologetics/HeroSection";
// Removed import for DifferenceSection as it's no longer needed
import ToolCards from "@/components/Apologetics/ToolCards";
import CallToAction from "@/components/Apologetics/CallToAction";

const Apologetics = () => {
  const [selectedTool, setSelectedTool] = useState<string | null>(null);
  const location = useLocation();

  // Use the scroll to top hook with smooth behavior
  useScrollToTop({ behavior: 'smooth' });

  // Reset tool selection when navigating directly to the apologetics page
  useEffect(() => {
    if (location.pathname === "/apologetics") {
      if (!location.hash) {
        setSelectedTool(null);
      }
    }
    const timer = setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  // Get tool from hash if present
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && ['biblical-defense', 'atheism', 'evangelism', 'evangelism-assistant', 'moral-dilemmas', 'interfaith-dialogue'].includes(hash)) {
      setSelectedTool(hash);
    }
  }, [location.hash]);

  if (selectedTool) {
    return <ToolSelector selectedTool={selectedTool} setSelectedTool={setSelectedTool} />;
  }

  return (
    <div className="min-h-screen bg-heaven-accent/50 relative overflow-hidden w-full">
      {/* Hero Section (full-bleed, before the containerized content) */}
      <HeroSection />

      {/* All following content is containerized and centered */}
      <div className="w-full px-4 py-4 relative z-10">
        {/* Removed DifferenceSection completely */}

        {/* The Apologetics Suite */}
        <ToolCards setSelectedTool={setSelectedTool} />

        {/* Call to Action */}
        <CallToAction setSelectedTool={setSelectedTool} />
      </div>
    </div>
  );
};

export default Apologetics;

